module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/e7c972c634096b89b182b99441a20b1d.svg";